import { createRoot, type Root } from 'react-dom/client';
import type { ReactElement } from 'react';
import { widgetCss } from '../WidgetShell.js';

const SHADOW_STYLE_ID = 'teo-widget-styles';
const SHADOW_MOUNT_ID = 'teo-widget-mount';

export function mountInShadow(
  hostElement: HTMLElement,
  render: (root: Root) => ReactElement,
): () => void {
  const shadow =
    hostElement.shadowRoot ??
    hostElement.attachShadow({ mode: 'open' });

  if (!shadow.getElementById(SHADOW_STYLE_ID)) {
    const style = document.createElement('style');
    style.id = SHADOW_STYLE_ID;
    style.textContent = widgetCss;
    shadow.appendChild(style);
  }

  let mount = shadow.getElementById(SHADOW_MOUNT_ID);
  if (!mount) {
    mount = document.createElement('div');
    mount.id = SHADOW_MOUNT_ID;
    shadow.appendChild(mount);
  }

  const root = createRoot(mount);
  root.render(render(root));

  return () => {
    root.unmount();
  };
}
